export interface INotesComponentsNumberedTitles {
    componentId: string;
    componentTitle: string;
    componentNumber: string | undefined;
    tableNumbers: string[];
}
